import { render, staticRenderFns } from "./AvatarGroup.vue?vue&type=template&id=11da114b&scoped=true&"
import script from "./AvatarGroup.vue?vue&type=script&lang=js&"
export * from "./AvatarGroup.vue?vue&type=script&lang=js&"
import style0 from "./AvatarGroup.vue?vue&type=style&index=0&id=11da114b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11da114b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
